import { Component, Vue } from 'vue-property-decorator';
import { environment } from '@/helpers/Environment';
import { getMyUpcomingSessions } from '@/helpers/OrderSessionHelpers';
import EventsList from '@/components/events/EventsList.vue';
@Component({
    components: { EventsList },
})
export default class UpcomingSessionsRoute extends Vue {
    loading = false;
    upcoming = null;
    // TODO: Remove these config options once we have confidence in this in production
    enabled = environment.config.my_account_pages?.upcoming_events ?? false;
    created() {
        this.loading = true;
        getMyUpcomingSessions()
            .then((upcoming) => (this.upcoming = upcoming))
            .finally(() => (this.loading = false));
    }
}
